// Global Variables
const targetNode = document.querySelector("#CollectionAjaxContent")


// Check if url has out of stock filter on load
window.addEventListener('load', () => {
    showSoldOut(targetNode)
})

// Options for the observer (which mutations to observe)
const config = {childList: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
   if (mutationList.length > 0) {
        showSoldOut(targetNode)
   }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);


const showSoldOut = (container) => {
    const searchParams = window.location.search
    if (searchParams.includes('filter.v.availability=0')) {
        const allSoldOuts = container.querySelectorAll('.grid-product__tag--sold-out')
        allSoldOuts.forEach(soldOut => {
            if (soldOut.classList.contains('hide')) {
                soldOut.classList.remove('hide')
            }
        });
    }
}